import { Component, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { UserService } from '@app/areas/user/user.service';
import { ForgotPasswordDTO } from '@app/_models/user/user';
import { BaseComponent } from '@app/base/basecomponent';
import { PersistenceService } from '@app/_services/persistence.service';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html'
})
/** forgot-password component*/
export class ForgotPasswordComponent extends BaseComponent implements OnInit {

  public forgotpwForm: UntypedFormGroup;
  public loading = false;
  public actionCompleted = false;

  get f() { return this.forgotpwForm.controls; }

  constructor(
    private userService: UserService,
    private persistence: PersistenceService
  ) {
    super();
  }

  ngOnInit() {
    //this.translate.setDefaultLang('fi');
    this.translate.use(this.persistence.getLang());

    this.forgotpwForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
    });
  }

  onSubmit() {
    if (!this.forgotpwForm.valid) {
      this.formError(this.forgotpwForm, 'login.errors.recover_form');
      return;
    }

    this.loading = true;

    var data = new ForgotPasswordDTO();
    data.userName = this.f.username.value;

    this.userService.forgotPassword(data).pipe(first()).subscribe(data => {
      this.loading = false;
      this.actionCompleted = true;
    }, (error) => {
      this.loading = false;
      this.errorHandler.applyErrors(this.forgotpwForm, error);
    });
  }
}
